import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { PenDesignTypeDto } from 'models/pen/PenDesignType';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class PenDesignTypeService extends BaseApiService<PenDesignTypeDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, PenDesignTypeDto);
  }

  async getPenDesignTypes(filters: QueryFilter) {
    return await this.httpClient.execWithResponseMeta<PenDesignTypeDto[]>(`api/pen-design-type/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }
}
